import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError, Field } from 'redux-form'
import { Breadcrumb, Button } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { MainBodyContent } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import GeneralInformation from '../Form/GeneralInformation'
import BankGuaranteeInformation from '../Form/BankGuaranteeInformation'
import VendorContact from '../Form/VendorContact'
import Attachment from '../Form/Attachment'
import { bgVendorRequestPath } from 'routes'
import { DocumentTypeContent } from './styled'
import { createBGRequest } from 'ducks/bankGuaranteeRequest'
import { validateRequestForm } from '../../../helper'
import { getVendors, getCompanies } from 'ducks/options'

const CreateBankGuaranteeRequest = (props) => {
  const { valueForm, change, vendorOptions, companyOptions } = props
  const [mainFormClickSave, setMainFormClickSave] = React.useState(false)
  const [submit, setSubmit] = React.useState(false)

  React.useEffect(() => {
    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }
  }, [])

  const onSubmitCreateForm = (values) => {
    if (mainFormClickSave) {
      const { createBGRequest, history } = props

      var errors = validateRequestForm(values)

      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        setMainFormClickSave(false)
        throw new SubmissionError(errors)
      } else {
        setMainFormClickSave(false)
        createBGRequest(values, submit, history)
      }
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle='Request Bank Guarantee - Create'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'Request Change/Return', link: true, onClick: () => props.history.push(bgVendorRequestPath) },
              { key: 'BGCreate', content: 'Create Request', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
        </div>
      }
    >
      <form onSubmit={props.handleSubmit((values) => onSubmitCreateForm(values))}>
        <DocumentTypeContent>Request for : 
          <Field 
            name='requestType' 
            label='' 
            type={type.radio}
            options={[
              { value: 'return', text: 'Return' },
              { value: 'change', text: 'Change' }
            ]}
            containerStyle={{ marginLeft: '10px' }}
            style={{ marginBottom: '0px' }}
            horizontalView
            component={FieldInput} />
        </DocumentTypeContent>
        <BankGuaranteeInformation valueForm={valueForm} change={change} />
        <GeneralInformation valueForm={valueForm} change={change} />
        <VendorContact change={change} formName='formBGRequest' />
        <Attachment valueForm={valueForm} change={change} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
          <Button
            type='submit'
            content='Save'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => {
              setMainFormClickSave(true)
              setSubmit(false)
            }}
          />
          <Button
            type='submit'
            content='Save & Submit'
            color='blue'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => {
              setMainFormClickSave(true)
              setSubmit(true)
            }}
          />
        </div>
      </form>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  const vf = getFormValues('formBGRequest')(state) || {}

  return ({
    user,
    username,
    valueForm: vf,
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
    initialValues: {
      ...vf,
      bgRelates: vf.bgRelates || [],
      requestType: vf.requestType || '',
      requesterUser: vf.requesterUser || username,
      newBankGuarantees: vf.newBankGuarantees || [],
      documentDate: vf.documentDate || new Date(),
      owner: vf.owner || 'vendor',
      creator: vf.creator || username
    },
  })
}

const mapDispatchToProps = {
  createBGRequest,
  getVendors, 
  getCompanies,
}

const validate = (values) => {
  let errors = validateRequestForm(values)

  return errors
}

const CreateBankGuaranteeRequestForm = reduxForm({
  form: 'formBGRequest',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(CreateBankGuaranteeRequest)

export default connect(mapStateToProps, mapDispatchToProps)(CreateBankGuaranteeRequestForm)
